var React = require('react');

function CurtainInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.5.5h21a1 1 0 0 1 1 1v2H.5v-2a1 1 0 0 1 1-1zM17.585 22.5H6.415M3.5 22a1.5 1.5 0 0 1-3 0V3.5","key":0}),React.createElement("path",{"className":"cls-1","d":"M6.5 3.5V22a1.5 1.5 0 0 1-3 0V7.465M20.5 22a1.5 1.5 0 0 0 3 0V3.5M17.5 3.5V22a1.5 1.5 0 0 0 3 0V7.465","key":1})]);
}

CurtainInline.defaultProps = {"className":"stroke","viewBox":"0 0 24 24"};

module.exports = CurtainInline;

CurtainInline.default = CurtainInline;
